import {createApp} from 'vue';
import * as components from './vue/components/return-portal';
import '../styles/main.css';

import './modules/lab_branding';

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

/* Create Vue instances function */
const createVueApp = () => {
  const app = createApp({});

  Object.entries(components).forEach(([name, module]) => {
    app.component(name, module);
  });

  return app;
};

const vueElements = document.querySelectorAll('[vue]');

if (vueElements) {
  vueElements.forEach((el) => {
    createVueApp().mount(el);
  });
}

/* properly render vue components on user insert in the theme editor */
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.value.includes('vue')) {
      createVueApp().mount(event.target);
    }
  });
}

/** ********************************************************************************** */
/** ********************************DO NOT EDIT BELOW********************************* */
/** ********************************************************************************** */

/**
 * Custom DOMready function
 * @param {*} callback
 */
const labDOMready = (callback) => {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};

/**
 * Use this event listener to run your JS after the DOM is ready
 */
labDOMready(() => {
  document.dispatchEvent(new CustomEvent('page:loaded'));
});
